import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

type Props = {
  active?: boolean
  children: ReactNode
  className?: string
}

/** Light overlay + shimmer while data refetches (keeps previous content visible). */
export function RefreshingRegion({ active = false, children, className }: Props) {
  return (
    <div
      className={cn('dashboard-refresh-region', active && 'dashboard-refresh-region--active', className)}
      aria-busy={active || undefined}
      aria-live="polite"
    >
      {children}
      {active ? <div className="dashboard-refresh-region__shimmer" aria-hidden /> : null}
    </div>
  )
}
